import React, { Component } from 'react';
import { Grid, Paper, Card, CardHeader, CardContent, Avatar, Typography, Button, Table, TableRow, TableCell, TableBody, Dialog, DialogContent, DialogActions, IconButton, Tooltip } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import EditIcon from '@material-ui/icons/Edit';
import TituloAccion from "../general/TituloAccion";
import AccionesRapidas from '../general/AccionesRapidas';
import BarraProceso from "../general/BarraProceso";
import TareasTerminadas from "../general/TareasTerminadas";
import DetalleAcompanamientoDocente from './DetalleAcompanamientoDocente';
import AppBarModal from '../general/AppBarModal';
import { BtnForm } from '../general/BotonesAccion';
import RegistroAcompanamientoModal from './RegistroAcompanamientoModal';
import { consulta } from '../../global/js/funciones';
import moment from 'moment';

// Imágenes quemadas
import revisar from '../../global/imagenes/revisar.png';
import study from '../../global/imagenes/study.png';
import medalla from '../../global/imagenes/medalla.png';
import emma_s from '../../global/imagenes/emma_s1.png';
import emma_w from '../../global/imagenes/emma_w.png';
import teaching from '../../global/imagenes/teaching.png';
import estudiante_icon from '../../global/imagenes/sisef_estudiante.png';

class ProcesosDocente extends Component {
  static defaultProps = {
    actualizarMensaje: () => {},
    usuario: null
  };
  constructor(props) {
    super(props);
    this.state = {
      seleccion: "proceso",
      enListado: true,
      procesoActual: {},
      render: false,
      procesosRecientes: [],
      cargando: false,
      modalDetalleAcompanamiento: false,
      modalVerEstudiantes: false,
      estudiantesParaCompletar: [],
      modalRegistroAcompanamiento: false,
      estudianteParaCompletar: null
    };
  }

  async componentDidMount() {
    this.obtenerDatosIniciales();
  }





  cambiarEstado = (estados) => {
    this.setState(estados);
  };

  getProcesosRecientes = () => {
    return new Promise(resolve => {
      consulta(`api/v1.0/acompanamiento_docente/recientes`, null, null, (error, estado, resp) => {
        resolve(estado === 200 && !error ? resp : null);
      })
    })
  }

  async obtenerDatosIniciales() {
    this.setState({ cargando: true, enListado: true, render: false });
    let procesosRecientes = await this.getProcesosRecientes();
    
    if (!procesosRecientes) {
      procesosRecientes = [];
    }
    
    this.setState({ procesosRecientes, cargando: false, render: true });
  }

  obtenerEstudiantesDelProcesoById = async (procesoId) => {
    return new Promise(resolve => {
      consulta(`api/v1.0/acompanamiento_docente/detalle/${procesoId}?`, null, null, (error, estado, resp) => {
        if (estado === 200 && !error && resp && resp[0] && resp[0].estudiantes) {
          resolve(resp[0].estudiantes);
        } else {
          resolve([]);
        }
      });
    });
  }

  pintarprocesosRecientes = () => {
    const { procesosRecientes } = this.state;
    
    if (procesosRecientes.length === 0) {
      return (
        <TareasTerminadas 
          mensaje='No hay procesos de acompañamiento docente disponibles' 
          imagen={emma_s} 
          widthImg='7%' 
          marginTop='7%' 
        />
      );
    }

    const handleClick = async (proceso) => {
      // Si no tiene estudiantes cargados, cargarlos
      if (!proceso.estudiantes) {
        const estudiantes = await this.obtenerEstudiantesDelProcesoById(proceso.id);
        proceso.estudiantes = estudiantes;
      }
      this.setState({ enListado: false, procesoActual: proceso });
    };

    return (
      <div style={{ padding: '2% 2% 0% 2%' }}>
        <Grid container direction={'row'} spacing={1}>
          <TituloAccion principal="" alterno="¡ Estos son los procesos de acompañamiento docente !" />
          {procesosRecientes.map((proceso, i) => {
            const obtenerColor = (codigo) => {
              const colores = {
                acom_docen_Regis: { backgroundColor: '#f5f5f5', color: '#757575' },
                acom_docen_Pendie: { backgroundColor: '#967300ff', color:'#757575ff' },
                acom_docen_Finali: { backgroundColor: '#009688', color: 'white' }
              };
              return colores[codigo] || { backgroundColor: '#f5f5f5', color: '#757575' };
            };
            
            return (
              <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                <Card 
                  onClick={() => handleClick(proceso)} 
                  className="pointer"
                  style={{ maxWidth: '100%', minHeight: '50px', height: '300px' }}
                >
                  <CardHeader
                    avatar={
                      <Avatar aria-label="Proceso" style={obtenerColor(proceso.estado_actual?.codigo)}>
                        {proceso.estado_actual?.nombre?.[0] || 'N'}
                      </Avatar>
                    }
                    title={proceso.tipo?.nombre || 'Sin tipo'}
                    subheader={moment(proceso.fecha_registro).format('YYYY-MM-DD')}
                  />
                  <CardContent>
                    <Grid container direction={'row'} justifyContent={'center'}>
                      <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'center', height: '150px' }}>
                        <img
                          src={teaching}
                          style={{ width: '100px', height: '100px' }}
                          alt="Acompañamiento Docente"
                        />
                        <Typography variant="body2" color="textSecondary" component="p" align="justify">
                          Proceso de acompañamiento para {proceso.docente_solicitante?.primer_nombre || 'N/A'} {proceso.docente_solicitante?.primer_apellido || ''} del programa {proceso.programa?.nombre || 'Sin asignar'}. Estado actual: {proceso.estado_actual?.nombre?.toLowerCase() || 'sin estado'}.
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </div>
    );
  };

  pintarProcesoActual = () => {
    const { procesoActual,render } = this.state;

    if (procesoActual && Object.keys(procesoActual).length > 0) {
      return (
        <div className=''>
          <Button
            onClick={() => this.setState({ enListado: true })}
            style={{ padding: '0px 3px 0px 3px', marginTop: '1%' }}
            color="secondary"
          >
            {' '}
            <ArrowBackIcon />{' '}
            <Typography variant="body2" style={{ color: '#9e9e9e' }} component="p" align="justify">
              {' '}
              Atras{' '}
            </Typography>{' '}
          </Button>
          <div style={{ padding: '2% 2% 0% 2%' }}>
            <Grid container direction={'row'} spacing={1}>
              <Grid item xs={12} sm={12} md={6}>
                <TituloAccion principal='' alterno='¡ Información Básica !' />
                <Paper elevation={0} square className="scroll">
                  {render && (
                    <Table>
                      <TableBody>
                        <TableRow>
                          <TableCell>Tipo</TableCell>
                          <TableCell>{procesoActual.tipo?.nombre || 'Sin tipo'}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Docente</TableCell>
                          <TableCell>{`${procesoActual.docente_solicitante?.primer_nombre || ''} ${procesoActual.docente_solicitante?.segundo_nombre || ''} ${procesoActual.docente_solicitante?.primer_apellido || ''} ${procesoActual.docente_solicitante?.segundo_apellido || ''}`.trim() || 'Sin asignar'}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Programa</TableCell>
                          <TableCell>{procesoActual.programa?.nombre || 'Sin asignar'}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Asignatura</TableCell>
                          <TableCell>{procesoActual.asignatura}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Grupo</TableCell>
                          <TableCell>{procesoActual.nombre_grupo_asignatura}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Periodo</TableCell>
                          <TableCell>{procesoActual.periodo}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Estado</TableCell>
                          <TableCell>{procesoActual.estado_actual?.nombre || 'Sin estado'}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Fecha Registro</TableCell>
                          <TableCell>{moment(procesoActual.fecha_registro).format('YYYY-MM-DD, h:mm a')}</TableCell>
                        </TableRow>
                        {procesoActual.observaciones && (
                          <TableRow>
                            <TableCell>Observaciones</TableCell>
                            <TableCell>{procesoActual.observaciones}</TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  )}
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={12} md={6}>
                <TituloAccion principal='' alterno='¿ Qué deseas hacer ?' />
                <Paper elevation={0} square className="scroll">
                  <Grid container direction={'row'} spacing={1} style={{ width: "100%" }}>
                    <Grid item xs={12} sm={12} md={12}>
                      <Paper elevation={1} style={{ border: '1px solid #e0e0e0' }} onClick={() => this.mostrarModalDetalleAcompanamiento(true)}>
                        <AccionesRapidas 
                          imagen={revisar} 
                          titulo='¡ Ver Detalles !' 
                          sub_titulo='Información' 
                          des_sub_titulo=', Aquí puedes ver toda la información del proceso.' 
                        />
                      </Paper>
                    </Grid>
                    {this.renderBotonVerEstudiante()}
                  </Grid>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={12} md={12}>
                <TituloAccion principal='' alterno='¿ Cómo va mi proceso ?' />
                {this.renderTiempo()}
              </Grid>
            </Grid>
          </div>
        </div>
      );
    } else {
      return (
        <TareasTerminadas 
          mensaje='No hay proceso activo de acompañamiento docente' 
          imagen={emma_s} 
          widthImg='7%' 
          marginTop='7%' 
        />
      );
    }
  };

  renderTiempo = () => {
    const { procesoActual } = this.state;
    
    if (procesoActual && procesoActual.estado_actual) {
      let activeStep = 0;
      let steps = [];
      
      // Mapear estados según los códigos reales del API
      const estadosReales = [
        { id: 'acom_docen_Regis', nombre: 'Registrado' },
        { id: 'acom_docen_Finali', nombre: 'Finalizado' }
      ];
      
      estadosReales.map((estado, i) => {
        if (estado.id === procesoActual.estado_actual.codigo) activeStep = i;
        steps.push({ label: estado.nombre });
        return true;
      });
      
      return <BarraProceso steps={steps} activeStep={activeStep} />;
    }
    return '';
  };

  mostrarModalDetalleAcompanamiento = (valor) => {
    this.setState({ modalDetalleAcompanamiento: valor });
  };

  cerrarModalDetalle = () => {
    this.setState({ modalDetalleAcompanamiento: false });
  };

  // Verificar si todos los estudiantes tienen campos vacíos
  verificarCamposVacios = (estudiantes) => {
    if (!estudiantes || estudiantes.length === 0) return false;
    
    return estudiantes.every(estudiante => 
      (!estudiante.descripcion_general || estudiante.descripcion_general.trim() === '') &&
      (!estudiante.seguimiento_realizado || estudiante.seguimiento_realizado.trim() === '') &&
      (!estudiante.verificación_grupo_priorizado || !estudiante.verificación_grupo_priorizado.nombre) &&
      (!estudiante.clasificacion_tipo_de_caso || estudiante.clasificacion_tipo_de_caso.length === 0)
    );
  }

  obtenerEstudiantesDelProceso = async () => {
    const { procesoActual } = this.state;
    if (!procesoActual || !procesoActual.id) return [];
    
    return new Promise(resolve => {
      consulta(`api/v1.0/acompanamiento_docente/detalle/${procesoActual.id}?`, null, null, (error, estado, resp) => {
        if (estado === 200 && !error && resp && resp[0] && resp[0].estudiantes) {
          resolve(resp[0].estudiantes);
        } else {
          resolve([]);
        }
      });
    });
  }

  mostrarModalVerEstudiantes = () => {
    const { procesoActual } = this.state;
    const estudiantes = procesoActual?.estudiantes || [];
    this.setState({ 
      modalVerEstudiantes: true, 
      estudiantesParaCompletar: estudiantes
    });
  }

  cerrarModalVerEstudiantes = () => {
    this.setState({ modalVerEstudiantes: false, estudiantesParaCompletar: [] });
  }

  renderBotonVerEstudiante = () => {
    const { procesoActual } = this.state;
    
    // Solo mostrar si hay proceso actual
    if (!procesoActual || Object.keys(procesoActual).length === 0) {
      return null;
    }
    
    // Verificar en tiempo real si hay estudiantes con campos vacíos
    const hayEstudiantesPendientes = procesoActual.estudiantes && 
      procesoActual.estudiantes.some(estudiante => this.estudianteTieneCamposVacios(estudiante));
    
    if (!hayEstudiantesPendientes) {
      return null;
    }
    
    return (
      <Grid item xs={12} sm={12} md={12}>
        <Paper elevation={1} style={{ border: '1px solid #e0e0e0' }} onClick={this.mostrarModalVerEstudiantes}>
          <AccionesRapidas 
            imagen={estudiante_icon} 
            titulo='¡ Ver Estudiante !' 
            sub_titulo='Estudiantes' 
            des_sub_titulo=', Aquí puedes ver y completar el registro de los estudiantes.' 
          />
        </Paper>
      </Grid>
    );
  }

  // Verificar si un estudiante individual tiene campos vacíos
  estudianteTieneCamposVacios = (estudiante) => {
    return (!estudiante.descripcion_general || estudiante.descripcion_general.trim() === '') &&
           (!estudiante.seguimiento_realizado || estudiante.seguimiento_realizado.trim() === '') &&
           (!estudiante.verificación_grupo_priorizado || !estudiante.verificación_grupo_priorizado.nombre) &&
           (!estudiante.clasificacion_tipo_de_caso || estudiante.clasificacion_tipo_de_caso.length === 0);
  }

  pintarEstudiantesParaCompletar = () => {
    const { estudiantesParaCompletar } = this.state;
    
    if (!estudiantesParaCompletar || estudiantesParaCompletar.length === 0) {
      return <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>No hay estudiantes para mostrar</div>;
    }
    
    // Filtrar solo estudiantes que necesitan completar registro
    const estudiantesPendientes = estudiantesParaCompletar.filter(estudiante => 
      this.estudianteTieneCamposVacios(estudiante)
    );
    
    if (estudiantesPendientes.length === 0) {
      return <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>Todos los estudiantes han completado su registro</div>;
    }
    
    return (
      <Table>
        <TableBody>
          {estudiantesPendientes.map((estudiante, index) => (
            <TableRow 
              key={index} 
              style={{ 
                backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff'
              }}
            >
              <TableCell style={{ padding: '16px', borderLeft: '4px solid #b70e0c' }}>
                <div style={{ 
                  color: '#b70e0c', 
                  fontWeight: 'bold', 
                  fontSize: '16px',
                  marginBottom: '8px'
                }}>
                  {estudiante.estudiante_acompanamiento ? 
                    `${estudiante.estudiante_acompanamiento.primer_nombre} ${estudiante.estudiante_acompanamiento.primer_apellido}` : 
                    'Estudiante'
                  }
                </div>
                <div style={{ color: '#666', fontSize: '14px', marginBottom: '4px' }}>
                  <strong>Cédula:</strong> <span style={{ color: '#333' }}>{estudiante.cedula_estudiante_acompanamiento || 'N/A'}</span>
                </div>
                <div style={{ color: '#666', fontSize: '14px' }}>
                  <strong>Correo:</strong> <span style={{ color: '#333' }}>{estudiante.estudiante_acompanamiento?.correo || 'N/A'}</span>
                </div>
              </TableCell>
              <TableCell style={{ textAlign: 'center', width: '80px' }}>
                <Tooltip title="Completar Registro">
                  <IconButton 
                    onClick={() => this.abrirModalRegistroAcompanamiento(estudiante)}
                    style={{ 
                      backgroundColor: '#b70e0c',
                      color: 'white',
                      '&:hover': { backgroundColor: '#8b0a09' }
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }

  abrirModalRegistroAcompanamiento = (estudiante) => {
    this.setState({ 
      modalRegistroAcompanamiento: true,
      estudianteParaCompletar: estudiante
    });
  }

  cerrarModalRegistroAcompanamiento = () => {
    this.setState({ 
      modalRegistroAcompanamiento: false,
      estudianteParaCompletar: null
    });
  }

  actualizarEstudiantes = async () => {
    // Recargar la lista de estudiantes después de actualizar
    const estudiantes = await this.obtenerEstudiantesDelProceso();
    
    // Actualizar el proceso actual con los nuevos datos
    const { procesoActual } = this.state;
    if (procesoActual) {
      procesoActual.estudiantes = estudiantes;
    }
    
    this.setState({ 
      estudiantesParaCompletar: estudiantes,
      procesoActual: procesoActual
    });
    this.cerrarModalRegistroAcompanamiento();
  }

  render() {
    const { seleccion, enListado, render, modalDetalleAcompanamiento, procesoActual, modalVerEstudiantes, modalRegistroAcompanamiento, estudianteParaCompletar } = this.state;
    const { actualizarMensaje, usuario } = this.props;
    
    // Determinar si es administrador basado en el perfil del usuario
    const administrador = usuario && (usuario.perfil.codigo === "Per_Adm" || usuario.perfil.codigo === 'Per_Acompana_Docen');
    
    return (
      <div>
        {render ? (
          <div>
            {seleccion === 'proceso' && (enListado ? this.pintarprocesosRecientes() : this.pintarProcesoActual())}
            <DetalleAcompanamientoDocente
              proceso={procesoActual}
              actualizarMensaje={actualizarMensaje}
              modalDetalleAcompanamiento={modalDetalleAcompanamiento}
              mostrarModalDetalleAcompanamiento={this.mostrarModalDetalleAcompanamiento}
              cerrarModal={this.cerrarModalDetalle}
              cargar="true"
              administrador={administrador}
              usuario={usuario}
            />
            
            {/* Modal Ver Estudiantes */}
            <Dialog fullWidth={true} maxWidth="md" open={modalVerEstudiantes} onClose={this.cerrarModalVerEstudiantes}>
              <AppBarModal titulo={" ¡ Detalle Acompañamiento Docente ! "} mostrarModal={this.cerrarModalVerEstudiantes} titulo_accion="Cerrar" accion={this.cerrarModalVerEstudiantes} />
              <DialogContent className='scroll'>
                <Grid container>
                  <Grid item xs={12} md={12}>
                    {this.pintarEstudiantesParaCompletar()}
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <BtnForm texto="Cerrar" callback={this.cerrarModalVerEstudiantes} />
              </DialogActions>
            </Dialog>

            {/* Modal Registro Acompañamiento */}
            <RegistroAcompanamientoModal 
              open={modalRegistroAcompanamiento}
              onClose={this.cerrarModalRegistroAcompanamiento}
              estudiante={estudianteParaCompletar}
              onActualizar={this.actualizarEstudiantes}
              actualizarMensaje={actualizarMensaje}
              cantidadEstudiantes={this.state.estudiantesParaCompletar?.filter(estudiante => this.estudianteTieneCamposVacios(estudiante)).length || 0}
            />
          </div>
        ) : (
          <TareasTerminadas mensaje="Cargando.." marginTop="7%" imagen={emma_w} widthImg="7%" cargando={true}/>
        )}
      </div>
    );
  }
}

export default ProcesosDocente;
